import { compose } from 'recompose';
import withMinorEligibility from 'hoc/withMinorEligibility';
import withSelectedPatientInfo from '../../hoc/withSelectedPatientInfo';
import withRoles from '../../hoc/withRoles';
import PatientInfo from './PatientInfo';

export default compose(withRoles, withSelectedPatientInfo, withMinorEligibility)(PatientInfo);
